import React from 'react'

import { useGetHrefProps } from './_hooks'

import type { IGetHrefPropsOptions } from './_hooks'
import type { LinkProps } from 'next/link'


import NextLink from 'next/link';
type NextLinkProps = Omit<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  keyof LinkProps
> &
  LinkProps & {
    children?: React.ReactNode
  } & React.RefAttributes<HTMLAnchorElement>

export interface ILinkProps
  extends NextLinkProps,
    Pick<IGetHrefPropsOptions, 'prefixOrigin'> {}

/* 解決 rewrites 实现的站群项目在跳转首页的时候，报错刷新到首页的问题 */
function Link(props: ILinkProps, ref: React.Ref<HTMLAnchorElement>) {
  const { href, as, prefixOrigin, locale, ...rest } = props

  if (typeof href === 'string' && href.trim() === '') {
    throw new Error('Unexpected empty href')
  }

  const getHrefProps = useGetHrefProps()
  const { hrefProps } = getHrefProps({ href, as, locale, prefixOrigin })

  return <NextLink ref={ref} prefetch={false} {...rest} {...hrefProps} />
}

const WrappedComponent = React.forwardRef(Link)
export default WrappedComponent
